import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DashboardRoutingModule } from './dashboard-routing.module';
import { GtapMaterialsModule } from '../gtap-materials/gtap-materials.module';
import { DashboardComponent } from './components/dashboard/dashboard.component';

@NgModule({
  declarations: [DashboardComponent],
  imports: [CommonModule, GtapMaterialsModule, DashboardRoutingModule],
})
export class DashboardModule {}
